<script setup>
import {useQuery} from "@vue/apollo-composable";
import {DeviceListQuery} from "@/graphql/queries/device/deviceList.graphql";
import {useResult} from "@/graphql/composable";
import {DeviceStatus, DeviceStatusLabel} from "./choices";
import {mdiCheckboxMarkedCircle, mdiCloseCircle, mdiTimerSand, mdiMagnify} from "@mdi/js";
import {HpoRoleLabel} from "../hpo/choices";
import {useSearch} from "@/search";

const {result, loading, refetch} = useQuery(DeviceListQuery, undefined, {
    fetchPolicy: "cache-and-network",
});
const deviceList = useResult(result, [], data => data.deviceList);
const {query, searchResultsOrAllItems: filteredDeviceList} = useSearch(deviceList, ['name']);

const headers = [
    {title: pgettext('label', 'Name'), key: 'name'},
    {title: pgettext('label', 'Status'), key: 'status'},
    {title: pgettext('label', 'Default Member Type'), key: 'defaultMemberType'},
    {title: pgettext('label', 'Created At'), key: 'createdAt'},
    {title: pgettext('label', 'Authenticated At'), key: 'authenticatedAt'},
];
const deviceStatusProps = {
    [DeviceStatus.WAITING_FOR_AUTH]: {color: 'blue', prependIcon: mdiTimerSand},
    [DeviceStatus.ACTIVE]: {color: 'green', prependIcon: mdiCheckboxMarkedCircle},
    [DeviceStatus.BLOCKED]: {color: 'red', prependIcon: mdiCloseCircle},
};

function refresh() {
    refetch();
}

defineExpose({refresh});
</script>

<template>
    <div class="d-flex align-center mb-4">
        <slot name="header-actions"></slot>
        <v-spacer />
        <v-text-field v-model="query" :label="pgettext('label', 'Search')" :prepend-inner-icon="mdiMagnify"
                      variant="solo-filled" density="comfortable" max-width="400" flat single-line hide-details/>
    </div>

    <v-divider />

    <v-data-table :headers="headers"
                  :items="filteredDeviceList"
                  :items-per-page="50"
                  :loading="loading">
        <template #item.name="{ item }">
            <strong>{{ item.name }}</strong>
        </template>
        <template #item.status="{ item }">
            <v-chip size="small" flat v-bind="deviceStatusProps[item.status]">{{ DeviceStatusLabel[item.status] }}</v-chip>
        </template>
        <template #item.defaultMemberType="{ item }">
            <template v-if="item.defaultMemberType">
                {{ HpoRoleLabel[item.defaultMemberType] }}
            </template>
            <em v-else>&ndash;</em>
        </template>
        <template #item.createdAt="{ item }">
            {{ formatShortDateTime(item.createdAt) }}
        </template>
        <template #item.authenticatedAt="{ item }">
            <template v-if="item.authenticatedAt">
                {{ formatShortDateTime(item.authenticatedAt) }}
            </template>
            <em v-else>&ndash;</em>
        </template>
    </v-data-table>
</template>
